"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var TreeInfoDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(TreeInfoDTOConverter, _DataObjectConverter_);

  function TreeInfoDTOConverter() {
    _classCallCheck(this, TreeInfoDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(TreeInfoDTOConverter).apply(this, arguments));
  }

  return TreeInfoDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.TreeInfoDTOConverter = TreeInfoDTOConverter;